import { Group, type GroupProps } from "@mantine/core"
import { Sticky } from "../layouts"

export function Filters(props: GroupProps) {
  return (
    <Sticky>
      <Group {...props} />
    </Sticky>
  )
}
